import { SvgBox, SvgBoxProps } from "@govlaunch/web";
import React from "react";

export default function ProjectPageTopIcon(props: SvgBoxProps) {
  return (
    <SvgBox width="24px" height="24px" viewBox="0 0 24 24" {...props}>
      <path d="M16 10H13V7H11V10H8V12H11V15H13V12H16V10Z" fill="#3F4A5A" />
      <path d="M15 22H9V24H15V22Z" fill="#3F4A5A" />
      <path
        d="M14.6 21H9.40004L7.64004 17.69C6.51998 16.9706 5.59931 15.9806 4.9631 14.8113C4.32689 13.642 3.99567 12.3312 4.00004 11C4.00004 8.87827 4.8429 6.84344 6.34319 5.34315C7.84348 3.84285 9.87831 3 12 3C14.1218 3 16.1566 3.84285 17.6569 5.34315C19.1572 6.84344 20 8.87827 20 11C20.0044 12.3312 19.6732 13.642 19.037 14.8113C18.4008 15.9806 17.4801 16.9706 16.36 17.69L14.6 21ZM10.6 19H13.4L14.85 16.27L15.09 16.13C15.9758 15.5979 16.7091 14.846 17.2189 13.9472C17.7287 13.0485 17.9978 12.0333 18 11C18 9.4087 17.3679 7.88258 16.2427 6.75736C15.1175 5.63214 13.5913 5 12 5C10.4087 5 8.88262 5.63214 7.7574 6.75736C6.63218 7.88258 6.00004 9.4087 6.00004 11C6.00403 12.0316 6.27392 13.0447 6.78366 13.9416C7.2934 14.8384 8.02576 15.5887 8.91004 16.12L9.15004 16.26L10.6 19Z"
        fill="#3F4A5A"
      />
    </SvgBox>
  );
}
